export default "__VITE_ASSET__CU0mcRV9__"